export default {
    BASE_URL: '/index',
    api: [
        {
            name: 'summary',
            desc: '获取头部项目汇总信息',
            method: 'GET',
            path: '/findAdminProjSummary'
        },
        {
            name: 'monthWorkPeople',
            desc: '每月出勤人数合计',
            method: 'GET',
            path: '/findMonthAttPersonalCnt'
        },
        {
            name: 'dayWorkPeople',
            desc: '每天各项目出勤人数排名',
            method: 'GET',
            path: '/findDayProjectAttSore'
        },
        {
            name: 'yearRecordAmounts',
            desc: '每年记工费用合计',
            method: 'GET',
            path: '/findYearWorkDataCost'
        },
        {
            name: 'monthRecordAmounts',
            desc: '每月各项目记工费用排名',
            method: 'GET',
            path: '/findMonthProjCostSore'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/dashboard/company.js